import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";


export default function WordpressDevelopment() {
  return (
    <div className="Wordpress-Development pt-[160px] sm:pt-0">
      <Helmet>
        <title>Best WordPress Development Dubai | WordPress Website UAE</title>
        <meta
          name="description"
          content="Get expert WordPress Web Design and Development in Dubai. Mean3 builds scalable, bilingual, and high-performance WordPress websites for UAE businesses"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section11 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
    </div>
  );
}
